// ****************************** Import From AWS Amplify ******************************** //

import '/src/amplify-config';

// ***************** CSS & Images ******************** //

import "./order.css";

// ************ Add Top Nav & Footer ***************** //

import '/src/nav-header-footer/nav-header-footer.js';
import '/src/nav-header-footer/nav-header-footer.css';

// ************ Add Email Signup Form *************** //

import '/src/nav-header-footer/email-signup-form.js';

// ********************* Images ********************** //

import "/src/assets/general-icons/right-arrow.svg";

import "/src/assets/box-designs/original-checked-pattern.svg";

import "/src/assets/images/fp-box-3028.jpg";



// ********************* JS for "Add To Cart" Button ********************** //

const button = document.getElementById('add-cart-button');

button.addEventListener('click', function() {
    sessionStorage.setItem("retroFoilsQuant", 1);
});


// ********************* JS for "View Items In Cart" Button ********************** //

var cartLink = document.getElementById("view-cart-link-container");

let cartItemCount = sessionStorage.getItem("retroFoilsQuant");
//console.log("cartItemCount: ", cartItemCount);

if (cartItemCount > 0) {
    cartLink.style.display = "block";
} else {
    cartLink.style.display = "none";
}




